<script setup lang="ts">
import { Locale } from 'shared/config/locale-config'
// import { useGlobalLoading } from 'shared/lib/composables/use-loading'
import { useLocaleStore } from 'shared/stores/locale.store'

const localeStore = useLocaleStore()

// const { isLoading } = useGlobalLoading()

localeStore.setLocale(Locale.RU)
</script>

<template>
  <!-- UApp — провайдер Nuxt UI (тосты, оверлеи, тултипы).
       MIOverlayProvider и MIToaster остаются, пока модалки и тосты не переведены на Nuxt UI. -->
  <UApp>
    <div>
      <!--    <LoadingSpinner :is-visible="isLoading" /> -->
      <RouterView />
      <MIOverlayProvider />
      <!-- Тосты выносим в body: у #app класс isolate (своя группа наложения), поэтому z-100 тостов
           внутри #app не перекрывает шторки/модалки mechtaui (z-50), которые рендерятся в body,
           и тосты при открытом окне (например, «Редактирование заказа») прятались под ним. -->
      <Teleport to="body">
        <MIToaster />
      </Teleport>
    </div>
  </UApp>
</template>
